<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-3 class="text-left fw-500">3. Account Use</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-3" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <p class="text-justify">The failure to supply us with the required personal data will potentially:</p>
                    <ol>
                        <li>Permissible Use: The VA may be used for electronic transactions, including but not limited to deposits, withdrawals, and transfers.</li>
                        <li>Prohibited Activities: The VA must not be used for any illegal activities, including money laundering, financing of terrorism, or fraudulent transactions.</li>
                        <li>Account Management: The Account Holder must ensure that all information provided during transactions is accurate and up-to-date.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-3',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>